var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay",class:{active: _vm.overlaying}})
}
var staticRenderFns = []

export { render, staticRenderFns }